import { render, staticRenderFns } from "./liveMatchesTwoStaticFloat.vue?vue&type=template&id=5a9decd1&scoped=true"
import script from "./liveMatchesTwoStaticFloat.vue?vue&type=script&lang=js"
export * from "./liveMatchesTwoStaticFloat.vue?vue&type=script&lang=js"
import style0 from "./liveMatchesTwoStaticFloat.vue?vue&type=style&index=0&id=5a9decd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9decd1",
  null
  
)

export default component.exports